import React from 'react';

const SearchIcon = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.4865 12.5135L13.486 12.514L13.492 12.5185C13.5545 12.5818 13.6042 12.6567 13.6383 12.7389C13.6729 12.8225 13.6907 12.912 13.6907 13.0025C13.6907 13.0929 13.6729 13.1825 13.6383 13.2661C13.6037 13.3496 13.5529 13.4256 13.489 13.4895C13.425 13.5535 13.3491 13.6042 13.2655 13.6388C13.1819 13.6735 13.0924 13.6913 13.0019 13.6913C12.9115 13.6913 12.8219 13.6735 12.7383 13.6388C12.6547 13.6042 12.5788 13.5535 12.5149 13.4895L9.54424 10.5183L9.50548 10.4795L9.46199 10.5129C8.31487 11.3932 6.87586 11.8041 5.43687 11.6625C3.99788 11.5208 2.66667 10.837 1.71327 9.74992C0.75987 8.66281 0.25568 7.25376 0.302977 5.80858C0.350274 4.36341 0.945517 2.99033 1.96796 1.9679C2.9904 0.945456 4.36347 0.350213 5.80865 0.302916C7.25382 0.255619 8.66288 0.759809 9.74998 1.71321C10.8371 2.66661 11.5208 3.99782 11.6625 5.43681C11.8042 6.8758 11.3932 8.31481 10.513 9.46193L10.4796 9.5054L10.5183 9.54416L13.4865 12.5135ZM1.68754 5.99998V6.00004C1.68871 7.14341 2.14343 8.23961 2.95192 9.04809C3.7604 9.85658 4.8566 10.3113 5.99997 10.3125H6.00004C6.85297 10.3125 7.68675 10.0596 8.39593 9.58569C9.10512 9.11182 9.65786 8.4383 9.98427 7.6503C10.3107 6.86229 10.3961 5.99519 10.2297 5.15865C10.0633 4.32211 9.65255 3.55369 9.04943 2.95058C8.44632 2.34746 7.67791 1.93674 6.84136 1.77034C6.00482 1.60394 5.13772 1.68934 4.34971 2.01575C3.56171 2.34215 2.88819 2.89489 2.41432 3.60408C1.94046 4.31327 1.68754 5.14704 1.68754 5.99998Z'
      fill='#AEABC0'
      stroke='#AEABC0'
      strokeWidth='0.125'
    />
  </svg>
);

export default SearchIcon;
